'use client';

import { Splide, SplideSlide, SplideTrack } from '@splidejs/react-splide';
import { TeamGridItem } from '@sapientpro/sapientpro-data-models';
import styles from './TeamValues.module.scss';
import '@splidejs/react-splide/css';
import TeamValueItem from './TeamValuesItem';

interface ITeamValuesSlideProps {
  items: TeamGridItem[],
  changeActive: (item: TeamGridItem | null) => void,
  handleHover: (itemId: number | null) => void;
  activeId?: number | null;
}

const TeamValuesSlider = ({
  items,
  changeActive,
  handleHover,
  activeId,
}: ITeamValuesSlideProps) => (
  <Splide
    className={styles.teamValuesSlider}
    options={{
      perPage: 1,
      arrows: false,
      pagination: false,
      gap: 16,
      autoWidth: true,
      padding: { left: 24, right: 24 },
      breakpoints: {
        374: {
          padding: { left: 6, right: 6 },
        },
      },
    }}
    hasTrack={false}
    id='teamValuesSlider'
  >
    <SplideTrack>
      {items.map(item => (
        <SplideSlide key={item.id}>
          <TeamValueItem
            item={item}
            changeActive={() => changeActive(item)}
            handleHover={handleHover}
            activeId={activeId}
          />
        </SplideSlide>
      ))}
    </SplideTrack>
  </Splide>
);

export default TeamValuesSlider;
